import { environment } from '../../environments/environment';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IWHMaterialInventoryDTO,
  IWHWorkerTimeReportResultDTO,
  WHPageableWorkerDOM,
  FLOW_GATEWAY,
  initHttpParams,
  WHHttpParams,
} from '@workheld/workheld-shared-lib';

@Injectable()
export class WorkerAsyncService {
  private readonly httpClient = inject(HttpClient);

  public getWorkerDtoList(
    params?: WHHttpParams,
  ): Observable<WHPageableWorkerDOM> {
    const httpParams: HttpParams = initHttpParams(params);
    return this.httpClient.get<WHPageableWorkerDOM>(
      `${environment.apiUrl + FLOW_GATEWAY}/workers`,
      { params: httpParams },
    );
  }

  public getWorkerTimeReport(
    workerId: string,
    startDate: string,
    endDate: string,
  ): Observable<IWHWorkerTimeReportResultDTO> {
    return this.httpClient.get<IWHWorkerTimeReportResultDTO>(
      `${environment.apiUrl + FLOW_GATEWAY}/workers/${workerId}/timereport/${startDate}/${endDate}`,
    );
  }

  public getWorkerWorkObjectWeeklyTimeReportCSV(
    workerId: string,
    startDate: string,
    endDate: string,
  ): Observable<HttpResponse<Blob>> {
    return this.httpClient.get<Blob>(
      `${environment.apiUrl + FLOW_GATEWAY}/workers/${workerId}/timereportcsv/${startDate}/${endDate}`,
      {
        observe: 'response',
        responseType: 'blob' as 'json',
      },
    );
  }

  public getWorkerMaterialInventory(
    workerId: string,
  ): Observable<IWHMaterialInventoryDTO> {
    return this.httpClient.get<IWHMaterialInventoryDTO>(
      `${environment.apiUrl + FLOW_GATEWAY}/workers/${workerId}/inventory`,
    );
  }
}
